import { Grid } from "@mui/material";
import { Fragment, useEffect, useState } from "react";

import { useAxios } from "../../../hooks";
import { PageHeader, Pagination } from "../../../components";
import List from "../campaign list components/List";
import { getSuperAdminCampaigns } from "../create campaign components/campaign form components/campaignObject";
import queryString from "query-string";

export default function SuperAdminCampaignList() {
  const axios = useAxios();
  const platformID = queryString.parse(window.location.search).platformID;
  const brandID = queryString.parse(window.location.search).brandID;
  const accountType = queryString.parse(window.location.search).accountType;
  const [page, setPage] = useState({
    page: 1,
  });
  const [loading, setLoading] = useState(false);
  const [sortBy, setSortBy] = useState("ALL");
  const [campaigns, setCampaigns] = useState([]);
  const [searchKey, setSearchKey] = useState("");
  const [brandList, setBrandList] = useState([]);
  const [filterBrand, setFilterBrand] = useState(brandID);
  const [categorize, setCategorize] = useState(platformID || "ALL");
  const [accountCategorize, setAccountCategorize] = useState(accountType);
  const [lastPage, setLastPage] = useState({ totalCount: 0, lastPage: false });

  useEffect(() => {
    setLoading(true);
    let url =
      "/user/brand/getAllCampaigns" +
      `?page=${page.page}&limit=10` +
      (Boolean(searchKey) ? `&search=${encodeURIComponent(searchKey)}` : "") +
      (sortBy !== "ALL" ? `&campaignStatus=${sortBy}` : "") +
      (categorize
        ? categorize !== 0
          ? `&partner_id=${categorize}`
          : "&partner_id=0"
        : "") +
      (filterBrand ? `&brand_id=${filterBrand}` : "") +
      (accountCategorize ? `&account_type=${accountCategorize}` : "");

    axios({
      url:
        "/getAllBrands" +
        (categorize
          ? categorize !== 0
            ? `?platform_id=${categorize}`
            : "?platform_id=0"
          : ""),
    }).then((response) => {
      if (response.status) {
        setBrandList(response.data.parsedBrands);
      }
    });

    axios({
      url: url,
      method: "GET",
    }).then((response) => {
      if (response.status) {
        if (response.data.formattedCampaigns.length > 0) {
          setLastPage({
            totalCount: response.data.totalCount,
            lastPage: response.data.formattedCampaigns.length < 10,
          });
          setCampaigns(getSuperAdminCampaigns(response));
        } else {
          setLastPage({
            totalCount: response.data.totalCount,
            lastPage: true,
          });
          setCampaigns(response.data.formattedCampaigns);
        }
      } else {
        setCampaigns([]);
      }
      setLoading(false);
    });
  }, [
    axios,
    categorize,
    accountCategorize,
    filterBrand,
    sortBy,
    searchKey,
    page.page,
  ]);

  function handlePagination(step, index) {
    setPage((prev) => ({
      page: step === "index" ? index : prev + (step === "next" ? 1 : -1),
    }));
  }

  return (
    <Fragment>
      <Grid container spacing={3}>
        <Grid size={12}>
          <PageHeader
            pageHeader={"List of campaigns"}
            pageName={"Campaign Offers"}
          />
        </Grid>
      </Grid>

      <List
        brandList={brandList}
        setBrandFilter={setFilterBrand}
        accountCategorize={accountCategorize}
        setAccountCategorize={setAccountCategorize}
        loading={loading}
        sortBy={sortBy}
        setSortBy={setSortBy}
        categorize={categorize}
        setPage={setPage}
        setSearchKey={setSearchKey}
        setCategorize={setCategorize}
        campaigns={campaigns}
        component="superadmin"
        filterBrand={filterBrand}
      />

      {!!lastPage.totalCount && (
        <Grid item container display={"flex"} justifyContent={"center"}>
          <Pagination
            count={Math.ceil(lastPage.totalCount / 10)}
            variant="outlined"
            color="secondary"
            page={page.page}
            onChange={(e, value) => handlePagination("index", value)}
          />
        </Grid>
      )}
    </Fragment>
  );
}
